import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar, expandLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { disableMapObject, enableMapObject } from '../../../action/disable-map-obj-state-action'
import IconBar from './icon-bar'
import Friends from './friends'
import ImportExport from './import-export'
import Layers from './layers'
import Search from './search'
import Settings from './settings'
import Tools from './tools'
import Editable from './editable'
import MyContent from './my-content'
import Profile from './profile'

class LeftToolbar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      containerWidth: ' '
    }
  }

  componentWillUnmount() {
    this.props.collapseLeftToolbar()
    this.props.enableMapObject()
  }

  // selectIcon(iconProps) {
  //   const { collapseLeftToolbar, expandLeftToolbar, enableMapObject, disableMapObject } = this.props,
  //     { dialog } = iconProps
  //   if (dialog !== null) {
  //     iconProps.dialog == 'tools' ? disableMapObject() : enableMapObject()
  //     expandLeftToolbar(iconProps)
  //   } else if (dialog === null) {
  //     collapseLeftToolbar()
  //     enableMapObject()
  //   }
  // }

  selectIcon(iconProps) {
    const { collapseLeftToolbar, expandLeftToolbar, enableMapObject, disableMapObject, leftToolbarState } = this.props;
    const { dialog } = iconProps;
    if (dialog !== null) {
      // iconProps.dialog == 'tools' ? disableMapObject() : enableMapObject();
      this.setState({ containerWidth: '440px' });
      if (leftToolbarState.expanded) {
        this.setState({ containerWidth: '78px' }, () => {
          setTimeout(() => {
            collapseLeftToolbar();
            this.setState({ containerWidth: '440px' }, () => {
              expandLeftToolbar(iconProps);
            });
          }, 150)
        });
      } else {
        expandLeftToolbar(iconProps);
      }
    } else if (dialog === null) {
      if (leftToolbarState.expanded) {
        this.setState({ containerWidth: '78px' }, () => {
          setTimeout(() => {
            collapseLeftToolbar();
            enableMapObject();
          }, 150);
        });
      } else {
        collapseLeftToolbar();
        enableMapObject();
      }
    }
  }

  getContent() {
    let { infoWindow } = this.props
    if (infoWindow) {
      infoWindow.infoWindowFunction && infoWindow.infoWindowFunction.close()
    }
    const selected = this.props.leftToolbarState.dialog
    switch (selected) {
      case 'layers':
        return <Layers />
      case 'myContent':
        return <MyContent />
      case 'settings':
        return <Settings />
      case 'tools':
        return <Tools />
      case 'friends':
        return <Friends />
      case 'importExport':
        return <ImportExport />
      case 'edit':
        return <Editable />
      case 'search':
        return <Search />
      case 'profile':
        return <Profile />
      default:
        return null
    }
  }

  render() {
    const { leftToolbarState } = this.props;
    const { containerWidth } = this.state;
    let totalWidth = leftToolbarState.expanded ? window.innerWidth > 1440 ? '500px' : '440px' : '78px'
    return (
      <div className={leftToolbarState.expanded ? 'handle-responsive-left-menu' : 'handle-responsive-left-menu-close'}
        style={{
          position: 'absolute', height: '100vh', display: 'flex', top: '0',
          width: leftToolbarState.dialog == 'edit' ? 440 : containerWidth,
        }}>
        <IconBar selectIcon={this.selectIcon.bind(this)} />
        {this.getContent()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  disableMapObj: state.disableMapObj,
  infoWindow: state.infoWindow
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  expandLeftToolbar: icon => dispatch(expandLeftToolbar(icon)),
  disableMapObject: () => dispatch(disableMapObject()),
  enableMapObject: () => dispatch(enableMapObject())
})

export default connect(mapStateToProps, mapDispatchToProps)(LeftToolbar)